export const dashboardLinks = [
  'home',
  'dash',
  'repBehavior',
  'reporting',
  'caseExplorer',
];

export const bmLinks = ['bookManagement', 'carrierPortal'];
